module.exports = __webpack_public_path__ + "static/media/bold-arrow-down.2cc612c6.svg";